import { render, staticRenderFns } from "./treasury.vue?vue&type=template&id=78ade7d2&scoped=true&"
import script from "./treasury.vue?vue&type=script&lang=js&"
export * from "./treasury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ade7d2",
  null
  
)

export default component.exports